import DeviceSuggestionCard from '../DeviceSuggestionCard'
import useViewModel from './EnergySystemSuggestionCard.viewmodel'

export type Props = Parameters<typeof useViewModel>[0]

export default function EnergySystemSuggestionCard(props: Props) {
  const viewModel = useViewModel(props)
  const { displayName, isLoadingOrIdle, articles } = viewModel

  if (isLoadingOrIdle) {
    return null
  }

  return (
    <DeviceSuggestionCard
      iconName="BatteryCharging"
      title={displayName}
      articles={articles}
    />
  )
}
